import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { withUiBlock } from '@bingads-webui/uiblocker';
import template from './subaccount-bid-multi-edit-template.pug';
import { processError } from '../error-mapping';
import { BidMultipliersView, EditPanelView, instrumentation } from '../hotel-center-shared';
import { bidMultiplierUtils } from '../hotel-center-utils';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const { showError } = globalContext.require('component/toast/index');


/**
 * Class representing a navigation tabs for SubAccount Edit Panel
 * @extends Base.View
 */

export default class SubAccountBidMultipliersEdit extends DeterministicView {
  /**
   * Initializes SubAccountBidEdit
   * @returns {undefined}
   */
  initialize({
    subAccountModel,
  }) {
    this.i18n = i18n;
    this.subAccountModel = subAccountModel;

    this.bidMultipliersView = new BidMultipliersView({
      showUseParent: false,
    });
    this.setChild('bid-multipliers-view-container', this.bidMultipliersView);

    this.editPanelView = new EditPanelView().setState({ hasCleanButton: true });
    this.setChild('edit-panel-view', this.editPanelView);
    this.editPanelView.on('saved', () => {
      this.onSave();
    }, this);
    this.editPanelView.on('canceled', () => {
      this.toggleVisibility();
    }, this);
    this.editPanelView.on('cleaned', () => {
      this.getChild('bid-multipliers-view-container').clean();
    }, this);

    this.subAccountModel.fetch().then(() => {
      this.updateBidMultipliersView();
    });
    this.subAccountBarScenario = instrumentation.subAccountBar.create();
  }

  get template() {
    return template;
  }

  toggleVisibility() {
    this.$('.light-dismissible').toggleClass('show');
  }

  onSave() {
    const bidMultipliers = this.getChild('bid-multipliers-view-container').getState();

    if (!bidMultipliers.isValid) {
      return;
    }

    this.subAccountModel.set(
      'BidMultipliers',
      bidMultipliers.bidMultipliers
    );

    const saveBidMultiplierActivity = this.subAccountBarScenario.saveBidMultiplier.create();

    saveBidMultiplierActivity.monitorAsync(this.subAccountModel
      .save(['BidMultipliers'], { patch: true }))
      .then(() => {
        const deviceTypeMultipliers = bidMultiplierUtils.getMultipliersText(this.subAccountModel.get('BidMultipliers'), false);

        this.toggleVisibility();
        this.trigger('bid-multipliers-changed', deviceTypeMultipliers);

        saveBidMultiplierActivity.trace('Sub-account multiplier is saved');
      })
      .catch((e) => {
        const errorInfo = e.errors ? processError({ errors: e.errors, scope: 'Subaccount', i18n }) : i18n.getString('GenericErrorMessage');
        showError(errorInfo);
      }).finally(withUiBlock($('.hotel-center-overview-container')));
  }

  updateBidMultipliersView() {
    if (!this.subAccountModel.get('BidMultipliers')) {
      return;
    }
    const bidMultipliers = bidMultiplierUtils.getMultipliersState(this.subAccountModel.get('BidMultipliers'));

    this.getChild('bid-multipliers-view-container').emptyDeviceTypeAndCheckInDay();
    this.getChild('bid-multipliers-view-container').setState({ bidMultipliers });

    this.bidMultipliersView.setState({ isPayPerStay: _.result(this.subAccountModel.get('Bid'), '@odata.type') === '#Model.PayPerStayBid' });
  }
}
